import { Component } from 'react';
import type { IServiceGraderPoolProvider } from '@common/interfaces';
import { AdminTable, TableHead, TableHeader, TableRow } from '@frontend/components/elements/common';
import { translateKey } from '@frontend/translate';
import { ServiceGraderPoolProviderListBody } from './ServiceGraderPoolProviderListBody';

export class ServiceGraderPoolProviderList extends Component<IPoolProviderListProps> {
    public render() {
        return (
            <AdminTable>
                <TableHead>
                    <TableRow>
                        <TableHeader>{translateKey('practitioner.practitioner')} </TableHeader>
                        <TableHeader>{translateKey('organization.organization')} </TableHeader>
                        <TableHeader>{translateKey('serviceGraderPool.maxPerMonth')} </TableHeader>
                        <TableHeader>{translateKey('serviceGraderPool.maxPerDay')} </TableHeader>
                        <TableHeader align="right">&nbsp; </TableHeader>
                    </TableRow>
                </TableHead>
                <ServiceGraderPoolProviderListBody
                    deleteServiceGraderPoolProvider={this.props.onDeleteRow}
                    editServiceGraderPoolProvider={this.props.onEditRow}
                    serviceGraderPoolProviders={this.props.serviceGraderPoolProviders}
                />
            </AdminTable>
        );
    }
}

interface IPoolProviderListProps {
    onDeleteRow: (serviceGraderPoolProviderId: string, serviceProviderId: string) => Promise<void>;
    onEditRow: (
        serviceProviderId: string,
        maxGradingsPerDay: number | null,
        maxGradingsPerMonth: number | null
    ) => Promise<void>;
    serviceGraderPoolId: string;
    serviceGraderPoolProviders: IServiceGraderPoolProvider[];
    serviceId: string;
}
